<template>
<div class="middle-page">
  <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E6%88%90%E5%8A%9F.svg"/>
  <h3>感谢您的提交</h3>
  <span>前往员工社区 -【星圈】继续探索复星圈内的事儿</span>
  <button @click="goHome">立即跳转 {{second}}s</button>
</div>
</template>
<script>
import { goHomePath } from '../../utils/power'
let time = 0
export default {
  data () {
    return {
      second: 5
    }
  },
  created () {
    this.updateSecond()
  },
  methods: {
    updateSecond () {
      clearTimeout(time)
      --this.second
      time = setTimeout(() => {
        if (this.second > 1) {
          this.updateSecond()
        } else {
          this.goHome()
        }
      }, 1000)
    },
    goHome () {
      clearTimeout(time)
      this.$router.push({
        path: goHomePath()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.middle-page {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    width: 80px;
    height: 80px;
  }
  h3 {
    margin-top: 32px;
    height:37px;
    font-size:26px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:37px;
  }
  span {
    font-size:17px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(136,136,136,1);
    line-height:26px;
    display: block;
    max-width: 192px;
    margin-top: 24px;
  }
  button {
    width:132px;
    height:44px;
    background:rgba(245,245,245,1);
    border-radius:4px;
    font-size:17px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
    line-height:24px;
    margin-top: 68px;
    border: none;
    outline: none;
  }
}
</style>
